import {
  AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID,
  CARS_WITHOUT_LICENSE_CATEGORY1_ID,
  CLASSIC_AND_COMPETITION_CATEGORY1_ID,
  DEFAULT_OFFER_TYPE_ID,
  OFFER_TYPE_DEMONSTRATION,
  OFFER_TYPE_KM0,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_NEW,
  OFFER_TYPE_SUBSCRIPTION,
  OFFER_TYPE_SUBSTITUTION,
  SEGUNDA_MANO_CATEGORY1_ID,
  UNSELECTED_OFFER_TYPE,
  VANS_AND_COMMERCIAL_CATEGORY1_ID
} from './ads.js'
import {PROFESSIONAL_STOCK_PAGE_NAME, PROFESSIONAL_STOCK_RENTING_PAGE_NAME} from './page.js'

export const DEFAULT_BIG_BANNER_ENABLED_RESPONSE = false
export const NO_ADVERTISING_PAGES = [PROFESSIONAL_STOCK_PAGE_NAME, PROFESSIONAL_STOCK_RENTING_PAGE_NAME]

export const PubRight1 = 'PubRight1'
export const PubRight2 = 'PubRight2'
export const PubLeft1 = 'PubLeft1'
export const PubLeft2 = 'PubLeft2'
export const PubInline1Desktop = 'PubInline1Desktop'
const PubInline2Desktop = 'PubInline2Desktop'
const PubInline1Mobile = 'PubInline1Mobile'
const PubInline2Mobile = 'PubInline2Mobile'
const PubInline3Mobile = 'PubInline3Mobile'
export const PubPhoto = 'PubPhoto'
export const PubTop1 = 'PubTop1'
export const PubTopC = 'PubTopC'
export const TextAds = 'TextAds'

const ListEventType = 'list'

export const AD_INLINE_BANNER_DESKTOP = 'bannerDesktop'
export const AD_INLINE_BANNER_MOBILE = 'inlineMobile'
export const AD_FORMAT_NATIVE_DESKTOP = 'nativeDesktop'
export const AD_FORMAT_NATIVE_MOBILE = 'nativeMobile'
export const AD_FORMAT_MULTIFORMAT_DESKTOP = 'multiformatDesktop'

export const EVENT_CHANNEL_INSURANCE = 'marketplace insurances'
export const EVENT_ID_DETAIL_CLICKED = 'insurances detail clicked'
export const EVENT_ID_POST_LEAD_DETAIL_CLICKED = 'insurances detail post-lead clicked'

export const EVENT_INSURANCE_CLICKED = 'Event Fired'
export const URL_INSURANCE_BUTTON = 'https://www.coches.net/seguros/?$$DATALAYER_PARAMS$$'

export const ADS_LIST_POSITIONS = {
  [TextAds]: {
    id: 'ad-textads'
  },
  [PubInline1Mobile]: {
    position: 5,
    format: AD_FORMAT_NATIVE_MOBILE,
    isMobile: true,
    id: 'ad-inline-1'
  },
  [PubInline2Mobile]: {
    position: 8,
    format: AD_INLINE_BANNER_MOBILE,
    isMobile: true,
    id: 'ad-inline-2'
  },
  [PubInline3Mobile]: {
    position: 18,
    format: AD_INLINE_BANNER_MOBILE,
    isMobile: true,
    id: 'ad-inline-3'
  },
  [PubInline1Desktop]: {
    position: 9,
    format: AD_FORMAT_NATIVE_DESKTOP,
    isDesktop: true,
    offset: '50% 0%',
    id: 'ad-inline-1'
  },
  [PubTopC]: {
    id: 'ad-top-c'
  },
  [PubInline2Desktop]: {
    position: 19,
    format: AD_FORMAT_NATIVE_DESKTOP,
    isDesktop: true,
    id: 'ad-inline-2'
  },
  [PubTop1]: {
    id: 'ad-top-1'
  },
  [PubRight1]: {
    id: 'ad-right-1'
  },
  [PubRight2]: {
    eventType: ListEventType,
    id: 'ad-right-2'
  },
  [PubLeft1]: {
    invCode: 'left_1',
    acceptedSizes: [
      [300, 250],
      [300, 300]
    ],
    saitama: {
      id: 'ad-footer-1'
    }
  },
  [PubLeft2]: {
    invCode: 'left_2',
    acceptedSizes: [
      [300, 250],
      [300, 300]
    ],
    saitama: {
      id: 'ad-footer-2'
    }
  },
  [PubPhoto]: {
    id: 'ad-photo'
  }
}

export const SEGMENTATION_CHANGED_EVENT_NAME = 'COCHES_SEGMENTATION_CHANGED'

export const VEHICLE_STATUS = {
  [-1]: {'es-ES': 'Ocasión'},
  0: {'es-ES': 'Ocasión'},
  1: {'es-ES': 'Nuevo'},
  2: {'es-ES': 'Km0'},
  3: {'es-ES': 'Sustitución'},
  4: {'es-ES': 'Gerencia'},
  5: {'es-ES': 'Demostración'}
}

export const VEHICLE_STATUS_RENTING = {'es-ES': 'Renting'}

export const FUEL_TYPES = {
  1: {'es-ES': 'Diésel'},
  2: {'es-ES': 'Gasolina'},
  3: {'es-ES': 'Eléctrico'},
  4: {'es-ES': 'Híbrido'},
  5: {'es-ES': 'Híbrido enchufable'},
  6: {'es-ES': 'Gas licuado (GLP)'},
  7: {'es-ES': 'Gas natural (CNG)'},
  8: {'es-ES': 'Otros'}
}

export const CATEGORY_LEVEL_RENTING = {
  'es-ES': 'Coches de renting y suscripción'
}

export const CATEGORIES_LEVEL_1 = {
  [SEGUNDA_MANO_CATEGORY1_ID]: {'es-ES': 'Coches'},
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: {
    'es-ES': 'Furgonetas y vehículos industriales'
  },
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: {
    'es-ES': 'Autocaravanas, caravanas y remolques'
  },
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: {'es-ES': 'Coches sin carnet'},
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: {
    'es-ES': 'Coches clásicos y competición'
  }
}

const ADS_NAME_PAGE_BASE = 'cochesnet'
export const ADS_NAME_PAGE_ADS_LIST_BASE = 'home'
export const ADS_NAME_PAGE_AD_DETAILS_BASE = 'ficha'
export const ADS_NAME_PAGE_AD_DETAILS_GALLERY_BASE = 'foto'

const ADS_NAME_PAGE_SECOND_HAND_OFFER_TYPE = 'ocasion'
const ADS_NAME_PAGE_OFFER_TYPE_KM0 = 'km0'
const ADS_NAME_PAGE_OFFER_TYPE_NEW = ADS_NAME_PAGE_OFFER_TYPE_KM0
const ADS_NAME_PAGE_OFFER_TYPE_SUBSTITUTION = ADS_NAME_PAGE_OFFER_TYPE_KM0
const ADS_NAME_PAGE_OFFER_TYPE_MANAGEMENT = ADS_NAME_PAGE_OFFER_TYPE_KM0
const ADS_NAME_PAGE_OFFER_TYPE_DEMONSTRATION = ADS_NAME_PAGE_OFFER_TYPE_KM0

const ADS_NAME_PAGE_VANS_AND_COMMERCIAL_DEFAULT_OFFER_TYPE = 'industriales'
const ADS_NAME_PAGE_AUTOCARAVANS_AND_TRAILERS_DEFAULT_OFFER_TYPE = 'caravanas'
const ADS_NAME_PAGE_CARS_WITHOUT_LICENSE_DEFAULT_OFFER_TYPE = 'sincarnet'
const ADS_NAME_PAGE_CLASSIC_AND_COMPETITION_DEFAULT_OFFER_TYPE = 'clasicos'

const ADS_NAME_PAGE_SUBSCRIPTION = 'renting'

const ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_SECOND_HAND_OFFER_TYPE}`
const ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_OFFER_TYPE_NEW = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_OFFER_TYPE_NEW}`
const ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_OFFER_TYPE_KM0 = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_OFFER_TYPE_KM0}`
const ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_OFFER_TYPE_SUBSTITUTION = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_OFFER_TYPE_SUBSTITUTION}`
const ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_OFFER_TYPE_MANAGEMENT = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_OFFER_TYPE_MANAGEMENT}`
const ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_OFFER_TYPE_DEMONSTRATION = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_OFFER_TYPE_DEMONSTRATION}`

const ADS_NAME_PAGE_VANS_AND_COMMERCIAL_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_VANS_AND_COMMERCIAL_DEFAULT_OFFER_TYPE}`
const ADS_NAME_PAGE_AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_AUTOCARAVANS_AND_TRAILERS_DEFAULT_OFFER_TYPE}`
const ADS_NAME_PAGE_CARS_WITHOUT_LICENSE_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_CARS_WITHOUT_LICENSE_DEFAULT_OFFER_TYPE}`
const ADS_NAME_PAGE_CLASSIC_AND_COMPETITION_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_CLASSIC_AND_COMPETITION_DEFAULT_OFFER_TYPE}`

export const ADS_NAME_PAGE_SUBSCRIPTION_DEFAULT = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_SUBSCRIPTION}`

export const ADS_NAME_PAGE_MAP = {
  [SEGUNDA_MANO_CATEGORY1_ID]: {
    [DEFAULT_OFFER_TYPE_ID]: ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID,
    [OFFER_TYPE_NEW]: ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_OFFER_TYPE_NEW,
    [OFFER_TYPE_KM0]: ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_OFFER_TYPE_KM0,
    [OFFER_TYPE_SUBSTITUTION]: ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_OFFER_TYPE_SUBSTITUTION,
    [OFFER_TYPE_MANAGEMENT]: ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_OFFER_TYPE_MANAGEMENT,
    [OFFER_TYPE_DEMONSTRATION]: ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_OFFER_TYPE_DEMONSTRATION,
    [OFFER_TYPE_SUBSCRIPTION]: ADS_NAME_PAGE_SUBSCRIPTION_DEFAULT,
    [UNSELECTED_OFFER_TYPE]: ADS_NAME_PAGE_SEGUNDA_MANO_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID
  },
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: {
    [DEFAULT_OFFER_TYPE_ID]: ADS_NAME_PAGE_VANS_AND_COMMERCIAL_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID,
    [OFFER_TYPE_SUBSCRIPTION]: ADS_NAME_PAGE_SUBSCRIPTION_DEFAULT
  },
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: {
    [DEFAULT_OFFER_TYPE_ID]: ADS_NAME_PAGE_AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID,
    [OFFER_TYPE_SUBSCRIPTION]: ADS_NAME_PAGE_SUBSCRIPTION_DEFAULT
  },
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: {
    [DEFAULT_OFFER_TYPE_ID]: ADS_NAME_PAGE_CARS_WITHOUT_LICENSE_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID,
    [OFFER_TYPE_SUBSCRIPTION]: ADS_NAME_PAGE_SUBSCRIPTION_DEFAULT
  },
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: {
    [DEFAULT_OFFER_TYPE_ID]: ADS_NAME_PAGE_CLASSIC_AND_COMPETITION_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID,
    [OFFER_TYPE_SUBSCRIPTION]: ADS_NAME_PAGE_SUBSCRIPTION_DEFAULT
  }
}

export const ADVERTISING_SITE = 'cn'

export const INSURANCE_CARD_CTA = 'VER OFERTA'
export const INSURANCE_PRODUCT_ID = 'insurance-car-v2'
export const INSURANCE_DETAIL_CARD_LOGOS_URL = `https://adit.gw.coches.net/twintail/v1/product/${INSURANCE_PRODUCT_ID}/logos/mosaic`
export const INSURANCE_DETAIL_CARD_LOGOS = [
  {
    name: 'Línea Directa',
    url: 'https://adit.gw.coches.net/twintail/v1/product/logos/eb4938be-a8e5-4f30-98f7-e9309ac836cb'
  },
  {name: 'Mutua Madrileña', url: 'https://a.dcdn.es/services/images/players/logo-rv/7.png'},
  {name: 'Mapfre', url: 'https://adit.gw.coches.net/twintail/v1/product/logos/df15ebff-c7d3-4339-bbb9-0c2472952591'}
]

export const DEFAULT_MAKE = 0
